import { forwardRef } from 'react';
import { getIcon } from '@common/lib/getIcon';
import { H2, StringXSmall } from '@components/Typography/Typography';
import cn from 'classnames';

import { CurrencyImage } from '../CurrencyImage/CurrencyImage';
import { Picture } from '../Picture/Picture';

import oneChipPng from '/img/one-chip.png';
import oneChipWebp from '/img/one-chip.webp';

interface RewardProps {
  kind: string;
  imageSize?: number | string;
  className?: string;
  value: string | number;
  label: string;
  weight?: {
    title?:
      | 'bold'
      | 'default'
      | 'regular'
      | 'medium'
      | 'semibold'
      | 'extrabold'
      | 'black'
      | null
      | undefined;
    descr?:
      | 'bold'
      | 'default'
      | 'regular'
      | 'medium'
      | 'semibold'
      | 'extrabold'
      | 'black'
      | null
      | undefined;
  };
}

const Reward = forwardRef<HTMLDivElement, RewardProps>(
  ({ kind, className, imageSize = '48px', value, label, weight }, ref) => {
    const image =
      kind === 'chip' ? { png: oneChipPng, webp: oneChipWebp } : getIcon(kind);

    return (
      <div ref={ref} className={cn('flex flex-col items-center', className)}>
        {image ? (
          <Picture
            className={`w-[${imageSize}] h-[${imageSize}]`}
            webp={image?.webp}
            img={image.png}
            alt="resource"
          />
        ) : (
          <CurrencyImage
            imageVariant="large"
            size={imageSize}
            kind={kind as 'cash' | 'tgem' | 'star'}
          />
        )}
        <H2
          weight={weight?.title || 'bold'}
          className={kind === 'star' ? '!text-gold' : 'text-white'}
        >
          +{value}
        </H2>
        <StringXSmall
          weight={weight?.descr || 'regular'}
          className="text-white/40"
        >
          {label}
        </StringXSmall>
      </div>
    );
  },
);

export { Reward };
